export default "__VITE_ASSET__zrqSQgFO__"